module.exports = __webpack_public_path__ + "img/Coccion.fa1fa917.png";